import { toast } from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { Modal } from "ui";

import { useQuizUpdate } from "../../../apis";
import { INITIAL_QUIZ_ITEM_FORM_VALUES } from "../../../constants";
import { QuizQuestionItem } from "../../../content.types";
import { QuizItemForm } from "../../forms";
import { QuizModalProps } from "./QuizModal.types";

const QUIZ_FORM_ID = "quiz-form-id";

const QuizModal = ({
  isOpen,
  onClose,
  editableItemIndex,
  quizzes,
  refetchQuiz,
  correctAnswersNeededToPass
}: QuizModalProps) => {
  const { t } = useTranslation();

  const quizUpdate = useQuizUpdate({
    onSuccess: () => {
      toast.success(t("Quiz has been updated successfully"));
      onClose();
      refetchQuiz();
    }
  });

  const handleFormSubmit = (formData: QuizQuestionItem) => {
    if (editableItemIndex !== null) {
      quizUpdate.mutate({
        correctAnswersNeededToPass,
        quizzes: quizzes.map((item, index) =>
          index === editableItemIndex ? formData : item
        )
      });
    } else {
      quizUpdate.mutate({
        correctAnswersNeededToPass: correctAnswersNeededToPass + 1,
        quizzes: [...quizzes, formData]
      });
    }
  };

  return (
    <Modal
      formId={QUIZ_FORM_ID}
      isOpen={isOpen}
      title={`${editableItemIndex ? "Edit" : "Add"} Question`}
      isLoading={quizUpdate.isLoading}
      okText={"Save"}
      onClose={onClose}
    >
      <QuizItemForm
        formId={QUIZ_FORM_ID}
        onSubmit={handleFormSubmit}
        defaultValues={
          editableItemIndex === null
            ? INITIAL_QUIZ_ITEM_FORM_VALUES
            : quizzes[editableItemIndex]
        }
      />
    </Modal>
  );
};

export default QuizModal;
